import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SetDeparture, SetPrices } from '../../../actions/cart';
import _map from 'lodash/map';
import _includes from 'lodash/includes';
import _uniqBy from 'lodash/uniqBy';
import dayjs from 'dayjs';
import DayPicker from 'react-day-picker';
import { ISOCurrencyCovert } from '../../../helpers/locationHelper';
import _orderBy from 'lodash/orderBy';

class Calender extends PureComponent {

  constructor(props){
    super(props);

    this.state = {
      selectedDay:null,
      activeDay:"",
      minDate:"",
      maxDate:"",
      currentDate:"",
      enabledDateOriginal:[],
      enabledDates:[],
      enabledPrice:[],
      selectdropdownValue:"",
      selectdropdownMonths:[],
      duration:0,
      months:["January", "February", "March","April","May","June","July","August","September","October","November","December"],
      priceAdult:[],
      availableDates:true,
      isYearOpen:false,
      availabileUnits:[],
      disabledDate:[]
    }

    this.handleYearMonthChange = this.handleYearMonthChange.bind(this);
    this.documentClickHandler = this.documentClickHandler.bind(this);
  }

  componentDidMount(){
   
    const { SetDeparture, capacity } = this.props;
   
    SetDeparture("");

    document.body.addEventListener('click', this.documentClickHandler);

   if(capacity.length !== 0) this.setUpCalender();

  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
  }

  documentClickHandler(e){
    try{
      if(e.target.offsetParent.className !== "filterDropdown basket" && e.target.offsetParent.className !== "calender"){
        if(this.state.isYearOpen) this.setState({isYearOpen: false});
      }
    }catch(e){}

  }

  monthSelectHelper(data){
    if (data.length > 0) {
      let uniqueMonth = _uniqBy(data, (item) => {
        return dayjs(item).format("YYYY-MM")
      });
      let monthMap = _map(uniqueMonth, (item) => {
        return dayjs(item).format('MMMM') + " " + dayjs(item).format('YYYY');
      });
      return monthMap;
    }else{
      return [dayjs().format('MMMM') + " " + dayjs().format('YYYY')];
    }
  }

  durationRemove(){
      let durationClass = document.querySelectorAll('[data-duration]');
      for(let i = 0; i < durationClass.length; i++){
        durationClass[i].setAttribute('data-duration', '');
      }
  }

  durationHelper(durationDays){

      // 1. Check if duration-calender class exist and remove all classes.
      // 2. Iterate through the durationDays array and add the class 'duration'

      this.durationRemove();

      for (let i = 0; i < durationDays.length; i++) {
          let daysAvailable = document.querySelectorAll('div[aria-label="'+durationDays[i]+'"]');
          if (daysAvailable.length > 0) {
                daysAvailable[0].setAttribute('data-duration', 'duration-calender');

              if(i === durationDays.length - 1){
                daysAvailable[0].setAttribute('data-duration', 'duration-calender-last');
              }
          }
      }

  }

  durationDays(departureDate, duration, calenderStr){

      let tempArr = [];

      // Populate temp array of duration days
      for(let i=1; i < duration; i++){
          if(calenderStr){
              let new_date = dayjs(dayjs(departureDate).toDate(), "YYYY-MM-DD").add(i, 'days').format("YYYY-MM-DD");
              let calender_str = "calendar-day-" + new_date;
              tempArr.push(calender_str);
          }else{
              let new_date = dayjs(dayjs(departureDate).toDate(), "YYYY-MM-DD").add(i, 'days').format('ddd MMM DD YYYY');
              tempArr.push(new_date);
          }
      }
      
      return tempArr;
  }

  durationReselect(){
    //retain duration highlight on month or year change

    /*if(this.state.selectedDay !== ""){
      if(this.state.selectdropdownValue === dayjs(this.state.selectedDay).format('MMMM YYYY')){
        setTimeout(() => {
          if(this.props.product.header.type !== "hoho" && this.props.product.header.tour_id !== "DAE"){
            this.durationHelper(this.durationDays(this.state.selectedDay, this.state.duration, false));
          }
        },10);
      }
    }*/

  }

  datesIsAfter(tourDatesArray, itinerary){

    if(!this.props.isBuilder) return;

    // List of new dates after last reservation date (don't show any dates before)
    let newDates = [];
    let lastReservationDate = dayjs(itinerary[itinerary.length - 1].date).add(itinerary[itinerary.length - 1].nights, 'day').format('YYYY-MM-DD');
    newDates = tourDatesArray.filter(item => { return new Date(item) >= new Date(lastReservationDate)});

    return newDates;
  }

  builderFilterDate(tourDateArray, capacityArray){
    if(!this.props.isBuilder) return;
    const formatTourDates = tourDateArray.map(o => { return dayjs(o).format('YYYY-MM-DD') } );
    const filteredCapacity = capacityArray.filter(item => formatTourDates.includes(item.departure_date));
    return filteredCapacity;
  }

  setUpCalender(){

    const currencyCode = (this.props.capacity === undefined && this.props.capacity.length !== 0) ? "" : ISOCurrencyCovert(this.props.capacity[0].prices[0].iso_currency_code).props.children;
    let toursDates = _orderBy(_map(this.props.capacity, "departure_date"), (o) => { return dayjs(o).format('YYYY-MM-DD') }, ['asc']);
    let newDatesMod = this.datesIsAfter(toursDates, this.props.itinerary); //Adventure planner / Itinerary - set minimum date from last reservation in booking
    let tourDateMod = _map(this.props.isBuilder ? newDatesMod : toursDates, (n) =>{ return dayjs(n).toDate() });

    let filteredDates = this.builderFilterDate(tourDateMod, this.props.capacity);
    let tourPriceAdult = _map(this.props.isBuilder ? filteredDates : this.props.capacity,  (n) =>{ return parseFloat(n.prices[0].amount).toFixed(2) });
    let tourPriceAdultMod = _map(tourPriceAdult, (n) =>{ return currencyCode + n });
    let availabileUnits = _map(this.props.isBuilder ? filteredDates : this.props.capacity, (n) => { return (n.units > 0 ) ? true : false; });    
    let capacityUnits = _map(this.props.isBuilder ? filteredDates : this.props.capacity, (n) => { return n.units });

    //reset calender
    this.props.SetDeparture("");
    this.durationRemove();

      this.setState({
        selectedDay:null,
        activeDay:"",
        minDate:tourDateMod[0],
        maxDate:tourDateMod[tourDateMod.length-1],
        currentDate:tourDateMod[0],
        enabledDateOriginal:(this.props.isBuilder) ? newDatesMod : toursDates,
        enabledDates:tourDateMod,
        enabledPrice:tourPriceAdultMod,
        selectdropdownMonths:this.monthSelectHelper(toursDates), //populate avaiable months for calender dropdown and show current calender months for tours with no dates
        duration:this.props.duration,
        priceAdult:tourPriceAdult,
        availableDates:true,
        availabileUnits:availabileUnits,
        capacityUnits:capacityUnits,
        disabledDate:(this.props.isBuilder) ? this.populateBuilderDisabledDate(newDatesMod) : []
      }, () => {

          //avoids error message FOUC
        this.setState({
          availableDates:(tourDateMod && tourDateMod.length === 0) ? false : true
        });

      });
  }

  componentDidUpdate(prevProps, prevState) {

    if(this.props.capacity !== prevProps.capacity){
      this.setUpCalender();
    }
  }

  populateBuilderDisabledDate(firstAvailableDate){

    let disableArr = [];
    const nextAvailableDate = firstAvailableDate[0];
    const nextAvailableDays = dayjs(firstAvailableDate[0]).get('date');

    for(let i = 1; i < nextAvailableDays; i++){
      disableArr.push(dayjs(nextAvailableDate).date(i).toDate())  
    }

    return disableArr;
  }

  handleDayClick = (day, { selected }) => {

    const selectedDay = dayjs(day).format('YYYY-MM-DD');
    const isAvailable = _includes(this.state.enabledDateOriginal, selectedDay );
    const index = this.state.enabledDateOriginal.indexOf(selectedDay);
    const notSoldout = this.state.availabileUnits[index];
    const { SetDeparture, SetPrices } = this.props;

    if(!notSoldout) return;

    this.setState({
      selectedDay: selected ? undefined : day
    });

    if(isAvailable && notSoldout){

      if(this.state.activeDay !== selectedDay){
  
        this.setState({activeDay:selectedDay})
     
        //set departure
        SetDeparture(selectedDay);

        //highlight duration dates - except hoho and Asia unlimited
        if(/*this.props.product.header.type !== "hoho" &&*/ this.props.productId !== "DAE"){
          this.durationHelper(this.durationDays(selectedDay, this.state.duration, false));
        }

        //set price 
        SetPrices(this.state.priceAdult[index]);

  
        //promo code - reset discount if non valid date is selected
      //  if(this.props.currentBooking.promo_code !== "" && this.props.discount.valid){
      //    this.props.DiscountReset();
      //  }

  
      }else{
        this.setState({activeDay:""})
        SetDeparture("");
        this.durationRemove();
      }
    }
    else{
      this.setState({activeDay:""})
      SetDeparture("");
      this.durationRemove();
    }

  };

  handleMonthClick = (day) => {

    this.setState({
      selectdropdownValue:dayjs(day).format('MMMM YYYY'),
      currentDate:dayjs(day).toDate()
    }, () => {
      this.durationReselect();
    });
  }
  
  renderPriceDay(day){
    let dayMod = dayjs(day).format('YYYY-MM-DD');
    let index = this.state.enabledDateOriginal.indexOf(dayMod);

    if(index !== - 1){
      return this.state.availabileUnits[index] ? this.state.enabledPrice[index] : "Sold out";
    }else{
      return <span>&nbsp;</span>;
    }
  }

  renderCalenderPriceClass(day){
    let dayMod = dayjs(day).format('YYYY-MM-DD');
    let index = this.state.enabledDateOriginal.indexOf(dayMod);

    if(index !== - 1){
      return this.state.availabileUnits[index] ? "" : "invalid";
    }else{
      return "";
    }
  }

  renderUnitsLeft(day){
    //render the number of units left if under 10
    let dayMod = dayjs(day).format('YYYY-MM-DD');
    let index = this.state.enabledDateOriginal.indexOf(dayMod);

    if(index !== - 1){
      if(this.state.availabileUnits[index]){
        if(this.state.capacityUnits[index] > 0 && this.state.capacityUnits[index] < 10){
          return this.state.capacityUnits[index] + ' left';
        }else{
          return <span style={{display:'none'}}>
            {this.state.capacityUnits[index] + ' left'}
          </span>;
        }
      }
    }else{
      return <span>&nbsp;</span>;
    }
  }

  renderDay(day){
    const date = day.getDate();

    return(
      <div>
        {date}
        <div className={`calender-price ${this.renderCalenderPriceClass(day)}`}>
          {this.renderPriceDay(day)}
        </div>

        <div className="units-left">
          {this.renderUnitsLeft(day)}
        </div>

      </div>
    )
  }

  handleYearMonthChange = (e, value) => {

    const _month = value.split(" ")[0];
    const _year = value.split(" ")[1];
    const _monthIndex = this.state.months.indexOf(_month);

    // Set the current drop down menu value and current calender date
    this.setState({
      selectdropdownValue:value,
      currentDate:new Date(_year, _monthIndex),
      isYearOpen:false,
      activeDay:""
    }, () => {
      this.durationReselect();
    });

  }

  onYearClick(e){
    e.preventDefault();
    this.setState({isYearOpen:!this.state.isYearOpen});
  }

  YearMonthForm(){
    const { isYearOpen, selectdropdownMonths } = this.state;

    const currentMonth = dayjs(this.state.currentDate).format('MMMM YYYY');

    return (
      <form className="DayPicker-Caption">
         <div className="clearfix mxn2">
          <div className="col-6 sm-col-4 lg-col-3 px2 mx-auto">
            <div className="filterDropdown basket">
              <div className="clearfix mxn2">
                <div className="col-12 px2 mx-auto">
                  <a onClick={ e => this.onYearClick(e) } className="filterDropdown-btn calender">
                  {currentMonth}

                  <svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg" className={`${isYearOpen ? 'active' : ''}`}>
                    <path fill="#ff6700" d="M1683 808l-742 741q-19 19-45 19t-45-19L109 808q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"/>
                  </svg>

                  <i className={`fa fa-chevron-down ${isYearOpen ? 'active' : ''}`} aria-hidden="true"></i>
                  </a>
                </div>
                <div className="col col-12 px2 mx-auto">
                  <ul className="calender" style={{display: isYearOpen ? 'block':'none' }}>
                    {
                      selectdropdownMonths.map((value, index) => {
                        return (
                          <li
                            value={value}
                            onClick={e => this.handleYearMonthChange(e, value)}
                            key={index}>{value}
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </div>
            </div>
         </div>
        </div>

      </form>
    )
  }


  render(){

    const { minDate, maxDate, enabledDates, selectedDay, currentDate, availableDates, disabledDate } = this.state;

        return (
          <React.Fragment>
          <p className="form-error calendar" style={{'display':(availableDates) ? 'none':'block' }}>
          Sorry. This departure is not available. The tour might have been sold out on the chosen date or is not available to book online. 
          </p>
          <DayPicker
            className={ (availableDates) ? '' : 'error'}
            showOutsideDays
            firstDayOfWeek={1}
            numberOfMonths={1}
            fromMonth={(minDate || null )}
            toMonth={(maxDate || null )}
            month={(currentDate || null)}
            value={selectedDay}
            selectedDays={selectedDay}
            onDayClick={this.handleDayClick}
            onMonthChange={this.handleMonthClick}
            canChangeMonth={true}
            modifiers={{
              available:enabledDates,
              outside:disabledDate
            }}
            renderDay={this.renderDay.bind(this)}
            captionElement={this.YearMonthForm.bind(this)}
            weekdaysShort={['SUN', 'MON', 'TUES', 'WED', 'THU', 'FRI', 'SAT']}
          />
          </React.Fragment>
        )

  }

}


const mapStateToProps = state => {
  return{
    duration:state.product.duration,
    productId:state.product.tourId,
    capacity:state.capacity,
    productName:state.product.name,
    itinerary:state.currentBooking.itinerary
  }
}


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    SetDeparture,
    SetPrices
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(Calender);
